module.exports = __webpack_public_path__ + "static/media/redirection-paiement.ee8970e7.svg";